import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { CounterpartiesTable } from "@/features/counterparties/counterparties-table";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_settings/einstellungen/debitoren",
)({
  component: DebtorsPage,
});

function DebtorsPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full w-full">
      <div className="font-bold text-xl mb-5">{t("debtors.link")}</div>
      <div className="flex-1">
        <CounterpartiesTable
          tableName="debtors"
          type="debtor"
          showImportButton={false}
        />
      </div>
    </div>
  );
}
